import _ from 'lodash';

const FORMSY_PROPS = [
    'setValidations',
    'setValue',
    'resetValue',
    'getValue',
    'hasValue',
    'getErrorMessage',
    'getErrorMessages',
    'isFormDisabled',
    'isValid',
    'isPristine',
    'isFormSubmitted',
    'isRequired',
    'showRequired',
    'showError',
    'showErrors',
    'isValidValue',
    'validationError',
    'validationErrors',
    'validations',
    'innerRef',
    'componentRef',
    'validateBeforeSubmit',
    'validatePristine'
];

function cleanFormsyProps(obj = {}) {
    return _.omit(obj, FORMSY_PROPS);
}

export default {
    cleanFormsyProps
}
